import { Box, Stack } from "@mui/material";
import {
  ColumnVisibilityFilter,
  SearchFilter,
  SectionHeader,
} from "@shared/components";
import { ColumnOptions } from "../utils/constants";
import {
  ColumnKey,
  FilterField,
  RoleManagementHeaderProps,
} from "../utils/types";

const filterFields: FilterField[] = [
  {
    id: "Search",
    name: "searchQuery",
    label: "Search",
    placeholder: "Search User",
    clearAriaLabel: "clear search",
  },
];

const RoleManagementHeader = ({
  visibleColumns,
  setVisibleColumns,
}: RoleManagementHeaderProps) => {
  return (
    <>
      <Box>
        <SectionHeader title="Role Management" />
        <Stack
          direction="row"
          spacing={2}
          justifyContent="space-between"
          mt={3}
          alignItems="center"
          sx={(theme) => ({
            border: `1px solid ${theme.palette.divider}`,
            borderBottom: 0,
            backgroundColor: "background.paper",
            padding: "15px",
            borderRadius: "4px 4px 0 0",
          })}
        >
          <SearchFilter filterFields={filterFields} />

          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
          >
            <ColumnVisibilityFilter
              value={visibleColumns as string[]}
              onChange={(vals) => setVisibleColumns(vals as ColumnKey[])}
              options={ColumnOptions}
              size="medium"
            />
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

export default RoleManagementHeader;
